<template>
    <div>
        <edit-production-crew-modal
            v-model="show_crew_dialog"
            :productionId="production.id"
            :modelProp="crewSelected"
            :constants="constants"
            :valuelists="valuelists"
            :members="membersList"
            @successful-save="refreshCrewData"
        />
        <div class="tw-p-1">
            <div>
                <internal-table-section :hasButton="false">
                    <div class="input-container relative">
                        <div class="tw-flex tw-justify-between tw-items-start">
                <span class="tw-text-secondary">
                    Production crew
                </span>
                <span class="tw-flex tw-justify-end">
                    <v-btn @click="emailCrew" :disabled="!fetch_data_response" class="main-btn tw-mr-4">
                        Email Crew
                    </v-btn>
                    <v-btn @click="addDefaultCrew" :loading="addDefaultCrewLoading" class="main-btn tw-mr-4">
                        Add Default Crew
                    </v-btn>
                     <v-btn @click="addCrew"class="main-btn">
                        Add Crew
                    </v-btn>
<!--                    <span class="tw-text-blue-500 custom-link" @click=""></span>-->

                </span>
                        </div>
                        <div class="mt-2">
                            <smart-table
                                id="productioncrews_list"
                                :endpoint="route('productioncrews.list', production.id)"
                                :headers="headers"
                                :items-per-page="20"
                                :footer-props="{
                                    'items-per-page-options': [5, 10, 20, 30]
                                }"
                                flat
                                class="row-pointer"
                                ref="productioncrews_list"
                                @click:row="editCrew"
                                @fetch-complete="receivedRecordsUpdate"
                            >
                                <template v-slot:item.include_in_report="{ isMobile, item, header, value, index}">
                                    <template v-if="item.include_in_report === '1'">
                                        <v-chip color="grey" dark>Include in report</v-chip>
                                    </template>
                                </template>

                            </smart-table>
                        </div>
                    </div>
                </internal-table-section>
            </div>
        </div>
    </div>
</template>


<script>
import SmartTable from "@/Generic/SmartTable";
import InternalHeader from "@/Generic/InternalHeader";
import InternalTableSection from "@/Generic/InternalTableSection";
import EditProductionCrewModal from "@/Pages/InternalPages/Productions/Modals/EditProductionCrewModal";

export default {
    name: "ProductionsShowCrew",
    components: {
        SmartTable,
        InternalHeader,
        InternalTableSection,
        EditProductionCrewModal,
    },
    props: {
        'input': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'valuelists': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
    },
    data() {
        return {
            production: this.input,
            crewSelected: this.crew,
            show_crew_dialog: false,
            constant: this.constants,
            filters: {
                production_id: this.input.id,
            },
            membersList: null,
            addDefaultCrewLoading: false,
            fetch_data_response: null,
        }
    },
    computed: {
        headers() {
            return [
                {value: 'user_id',              text: 'Member ID',          align: 'start',     sortable: false,        optional: false},
                {value: 'first_name',           text: 'First name',         align: 'start',     sortable: false,        optional: false},
                {value: 'last_name',            text: 'Last name',          align: 'start',     sortable: false,        optional: false},
                {value: 'note',                 text: 'Notes',              align: 'start',     sortable: false,        optional: false},
                {value: 'note_private',         text: 'Non-Print Notes',    align: 'start',     sortable: false,        optional: false},
                {value: 'date_start',           text: 'Start Date',         align: 'start',     sortable: false,        optional: false},
                {value: 'date_stop',            text: 'Stop Date',          align: 'start',     sortable: false,        optional: false},
                {value: 'camera',               text: 'Camera',             align: 'start',     sortable: false,        optional: false},
                {value: 'unit',                 text: 'Unit',               align: 'start',     sortable: false,        optional: false},
                {value: 'name',                 text: 'Function',           align: 'start',     sortable: false,        optional: false},
                {value: 'priority',             text: 'Priority',           align: 'start',     sortable: false,        optional: false},
                {value: 'include_in_report',    text: 'Include in Report',  align: 'start',     sortable: false,        optional: false},
                {value: 'production_id',        text: 'Production',         align: ` d-none`,   sortable: false,   filterable: true,   search: this?.filters?.production_id,                                    optional: false, },
            ]
        },

        is_edit_mode() {
            return this.mode == 'Edit' ? true : false
        },
    },
    mounted() {
        this.getDeferredValuelists()
    },
    methods: {
        getDeferredValuelists() {
            axios.post(route('members.valuelist'))
                .then((response)=>{
                    this.membersList = response?.data?.filter((member) => member.text != 0 )
                })
        },
        addCrew() {
            this.crewSelected = null
            this.show_crew_dialog = true
        },
        addDefaultCrew(){
            let url = route('productions.add-default-crew')
            let payload = this.production;


            axios({
                url: url,
                method: 'post',
                data: payload,
                onUploadProgress: (evt) => {
                    this.addDefaultCrewLoading = !this.addDefaultCrewLoading;
                    this.$refs.productioncrews_list.refreshList()

                },
                onDownloadProgress: (evt) => {
                    this.addDefaultCrewLoading = !this.addDefaultCrewLoading;
                },
            })
                .then(response => {
                    if (response.data.success) {
                        this.$root.snackbar.success('Default Crew Added');
                        this.addDefaultCrewLoading = false;
                    } else {
                        this.addDefaultCrewLoading = false;
                        throw (response.data.error)
                    }
                })
                .catch((error) => {
                    this.$root.snackbar.error(error);
                    this.addDefaultCrewLoading = false;
                })

            // axios.post(route('productions.add-default-crew',  this.production.id))
            //     .then((response)=>{
            //         // this.membersList = response?.data?.filter((member) => member.text != 0 )
            //         this.addDefaultCrewLoading = false;
            //
            //     })
            this.addDefaultCrewLoading = false;
        },
        editCrew(item) {
            this.crewSelected = item
            this.show_crew_dialog = true
        },
        refreshCrewData() {
            this.$refs.productioncrews_list.refreshList()
        },
        saveStatistics() {
            //
        },
        receivedRecordsUpdate(response) {
            this.fetch_data_response = response;
        },
        emailCrew() {
            let memberList = this.fetch_data_response.data.data;
            let emailList = memberList.map(user => user.email).join(';')
            let subject = this.input.name
            window.location.href = "mailto:" + emailList + "?subject=" + subject
        }
    }
}
</script>

<style>

</style>
